
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
  },
  model: {
    prop: 'modelValue',
    event: 'change',
  }
})
export default class Checkbox extends Vue {
    @Prop() value: any;
    @Prop() modelValue: any;
    @Prop({ type: Boolean, default: true }) trueValue: boolean;
    @Prop({ type: Boolean, default: false }) falseValue: boolean;

    @Prop({ type: String, default: '' }) form: string;
    @Prop({ type: String, default: '' }) name: string;
    @Prop({ type: String, required: false }) label: string;
    @Prop({ type: String, default: 'normal' }) size: string;
    @Prop({ type: String, default: 'primary' }) variant: string;
    @Prop({ type: Boolean, default: false }) disabled: boolean;

    get classes() {
      return {
        'cbx-primary': this.variant === 'primary',
        'cbx-secondary': this.variant === 'secondary',
        normal: this.size === 'normal',
        [this.name]: true,
      }
    }

    get isChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value)
      } else if (typeof this.modelValue === 'number') {
        return this.modelValue === this.value;
      }
      // Note that `true-value` and `false-value` are camelCase in the JS
      // return this.modelValue === (this.value || this.trueValue);
      return this.modelValue === this.trueValue;
    }

    updateInput(event) {
      const isChecked = event.target.checked
      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue];
        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }
        this.$emit('change', newValue);
      } else if (typeof this.modelValue === 'number') {
        this.$emit('change', this.value);
      } else {
        this.$emit('change', isChecked ? this.trueValue : this.falseValue);
      }
    }
}
